import ex from "../styles/mapa.module.css"
import cx from "classnames"

export default function Mapa() {
    return (
        <>
            <img src="/images/mapas/mapa_eng.png"/>
        </>
    )
}